import React from "react";

const ScoringNotify = ({ id, onClose, sendDataToParent , selectedBuilder, setScoreVisible, message,process}) => {
  const handleClose = () => {
    if (onClose) onClose(id);
    else setScoreVisible(false);
  };
  const sendMessage = (e) => {
    e.preventDefault();
        // Send data to parent
        sendDataToParent(true);
    };
    const isSelfEval = process === 'Self Evaluation';
    const isSelfEvalFailed = process === 'Self Evaluation Failed';
    return (
      <div className="pof2frms-scoring-notify">
          {isSelfEvalFailed ? (
              <>
                  <h3>Self Evaluation Failed Complete</h3>
                  <h4>❌ Self Evaluation FAILED</h4>
              </>
          ) : isSelfEval ? (
              <>
                  <h3>Self Evaluation Complete</h3>
                  <h4>{message}</h4>
              </>
          ) : (
              <>
                  <h3>{process} Complete</h3>
                  <h4>{message}</h4>
                  <p>
                      File: Builder {selectedBuilder} <a href="/builder-rules">View</a>
                  </p>
              </>
          )}
          <a onClick={handleClose} className="pof2frms-popup-close" aria-label="close-popup"></a>
      </div>
  );
};

export default ScoringNotify;
